import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { secondsToHHMMSS, sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../helper/utility";
import { dashBoardReportAction, dashBoardReportRegisteredUsersAction, dashBoardReportWorkOutSessionsAction } from "../../Redux/Actions/DashboardReportAction";
import { Constants } from "../Common/Constants";
import AreaGraph from "../Common/Graphs/AreaGraph";
import BarGraph from "../Common/Graphs/BarGraph";


dayjs.extend(utc);
dayjs.extend(timezone);

const Yearly = () => {
  // const { dashboardData } = useSelector((store) => store.Dashboard);


  const { male, female, total } = useSelector((store) => store.dashBoardReportReducer.activeUsers);
  const uniqueActiveUsersMale = useSelector((store) => store.dashBoardReportReducer.activeUsers.uniqueActiveUsers.male);
  const uniqueActiveUsersFemale = useSelector((store) => store.dashBoardReportReducer.activeUsers.uniqueActiveUsers.female);
  const registeredUsers = useSelector((s) => s.dashBoardReportReducer.registeredUsers);
  const workOutSessions = useSelector((store) => store.dashBoardReportReducer.workOutSessions);
  const totalDuration = useSelector((store) => store.dashBoardReportReducer.totalDuration);

  const sumOfRegisteredUsers = sumOfRecordCountsWithoutDecimal(registeredUsers);
  const sumOfWorkoutSessions = sumOfRecordCountsWithoutDecimal(workOutSessions);
  const sumOfTotalDuration = sumOfRecordCounts(totalDuration);
  // const sumOfMale = sumOfRecordCounts(male);
  // const sumOfFemale = sumOfRecordCounts(female);
  // const sumOfTotal = sumOfRecordCounts(total);

  const dispatch = useDispatch();
  useEffect(function () {
    const today = new Date();

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const tz = dayjs.tz.guess();


    const formattedDate = tomorrow.toISOString().split("T")[0];
    dispatch(dashBoardReportAction({ noOfDays: 365, currentDate: formattedDate, tz }));
    dispatch(dashBoardReportRegisteredUsersAction({ noOfDays: 365, currentDate: formattedDate, tz }));
    dispatch(dashBoardReportWorkOutSessionsAction({ noOfDays: 365, currentDate: formattedDate, tz }));
  }, []);

  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <BarGraph
          // data={dashboardData?.registeredUserYearly}
          data={registeredUsers}
          // title={Constants.totalRegisteredUsers}
          title={`${Constants.totalRegisteredUsers} ${sumOfRegisteredUsers}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <BarGraph
          // data={dashboardData?.totalActiveUserYear}
          data={total}
          // title={Constants.totalActiveUsers}
          title={`${Constants.totalActiveUsers} ${uniqueActiveUsersMale ? uniqueActiveUsersMale + uniqueActiveUsersFemale : 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <BarGraph
          // data={dashboardData?.activeMaleUsersyear}
          data={male}
          // title={Constants.totalActiveUsersMale}
          title={`${Constants.totalActiveUsersMale} ${uniqueActiveUsersMale || 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={dashboardData?.activeFeMaleUsersyear}
          data={female}
          // title={Constants.totalActiveUsersFemale}
          title={`${Constants.totalActiveUsersFemale} ${uniqueActiveUsersFemale || 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={dashboardData?.lastyearWorkoutSession}
          data={workOutSessions}
          // title={Constants.totalWorkoutSessions}
          title={`${Constants.totalWorkoutSessions} ${sumOfWorkoutSessions}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={dashboardData?.avgWorkoutDurationYearly}
          data={totalDuration}
          // title={Constants.totalWorkoutSessionDuration}
          title={`${Constants.totalWorkoutSessionDuration} ${secondsToHHMMSS(sumOfTotalDuration)}`}
          format=""
          yAxisType={"time"}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Yearly;
